var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-input",
            {
              staticClass: "filter-item",
              staticStyle: { width: "300px" },
              attrs: { placeholder: "Search by SKU Code or Name" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleFilter.apply(null, arguments)
                },
              },
              model: {
                value: _vm.listQuery.search,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "search", $$v)
                },
                expression: "listQuery.search",
              },
            },
            [
              _c("el-button", {
                attrs: { slot: "append", icon: "el-icon-search" },
                on: { click: _vm.handleFilter },
                slot: "append",
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Product Type", clearable: "" },
              on: { change: _vm.handleFilter },
              model: {
                value: _vm.listQuery.productType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "productType", $$v)
                },
                expression: "listQuery.productType",
              },
            },
            [
              _c("el-option", { attrs: { label: "V1", value: "V1" } }),
              _c("el-option", { attrs: { label: "V2", value: "V2" } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Status", clearable: "" },
              on: { change: _vm.handleFilter },
              model: {
                value: _vm.listQuery.isActive,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "isActive", $$v)
                },
                expression: "listQuery.isActive",
              },
            },
            [
              _c("el-option", { attrs: { label: "Active", value: "true" } }),
              _c("el-option", { attrs: { label: "Inactive", value: "false" } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" Add SKU ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.getList },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            data: _vm.skus,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "SKU Code", align: "left", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-family": "monospace",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(row.skuCode))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Name", align: "left", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _c("strong", [_vm._v(_vm._s(row.name))]),
                      row.description
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                                "margin-top": "4px",
                              },
                            },
                            [_vm._v(" " + _vm._s(row.description) + " ")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Product Type", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: { type: _vm.getProductTypeTag(row.productType) },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatProductType(row.productType)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Features", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.features && row.features.length > 0
                      ? _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-start",
                              width: "300",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "div",
                              _vm._l(row.features, function (f) {
                                return _c(
                                  "div",
                                  {
                                    key: f.id,
                                    staticStyle: { "margin-bottom": "8px" },
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "small", type: "info" },
                                      },
                                      [_vm._v(_vm._s(f.featureKey))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "8px",
                                          "font-size": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              f.durationType === "permanent"
                                                ? "Permanent"
                                                : `${f.durationValue} ${f.durationType}`
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "mini",
                                  type: "info",
                                },
                                slot: "reference",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(row.features.length) +
                                    " feature(s) "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "warning", size: "small" } },
                          [_vm._v("No features")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: row.isActive ? "success" : "danger",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(row.isActive ? "Active" : "Inactive") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "280",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "success",
                          icon: "el-icon-setting",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleManageFeatures(row)
                          },
                        },
                      },
                      [_vm._v(" Features ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v(" Delete ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogStatus === "create" ? "Create SKU" : "Edit SKU",
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "SKU Code", prop: "skuCode" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., WW-V2-PLUS-VA-1Y",
                      disabled: _vm.dialogStatus === "edit",
                    },
                    model: {
                      value: _vm.formData.skuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skuCode", $$v)
                      },
                      expression: "formData.skuCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., WeWalk V2 Plus with 1 Year VA",
                    },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Brief description of this SKU",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Product Type", prop: "productType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select product type" },
                      model: {
                        value: _vm.formData.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "productType", $$v)
                        },
                        expression: "formData.productType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "V1", value: "V1" } }),
                      _c("el-option", { attrs: { label: "V2", value: "V2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isActive", $$v)
                      },
                      expression: "formData.isActive",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus === "create"
                        ? _vm.createSkuHandler()
                        : _vm.updateSkuHandler()
                    },
                  },
                },
                [_vm._v(" Confirm ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Manage SKU Features",
            visible: _vm.featuresDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.featuresDialogVisible = $event
            },
          },
        },
        [
          _vm.selectedSku
            ? _c(
                "div",
                [
                  _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                    _c("strong", [_vm._v("SKU:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.selectedSku.skuCode) +
                        " - " +
                        _vm._s(_vm.selectedSku.name) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-card",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { shadow: "never" },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("Current Features")]),
                      ]),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.selectedSku.features,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Feature", prop: "featureKey" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Name", prop: "featureName" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Duration", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            row.durationType === "permanent"
                                              ? "Permanent"
                                              : `${row.durationValue} ${row.durationType}`
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3909357330
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Status", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: row.isActive
                                              ? "success"
                                              : "danger",
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.isActive
                                                  ? "Active"
                                                  : "Inactive"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2225569341
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Actions", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemoveFeature(row)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2381620985
                            ),
                          }),
                        ],
                        1
                      ),
                      !_vm.selectedSku.features ||
                      _vm.selectedSku.features.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                                color: "#909399",
                              },
                            },
                            [_vm._v(" No features assigned to this SKU yet ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { attrs: { shadow: "never" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("Add Feature")]),
                      ]),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            model: _vm.newFeatureForm,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Feature" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: { placeholder: "Select feature" },
                                  model: {
                                    value: _vm.newFeatureForm.featureId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newFeatureForm,
                                        "featureId",
                                        $$v
                                      )
                                    },
                                    expression: "newFeatureForm.featureId",
                                  },
                                },
                                _vm._l(_vm.availableFeatures, function (f) {
                                  return _c("el-option", {
                                    key: f.id,
                                    attrs: {
                                      label: `${f.name} (${f.featureKey})`,
                                      value: f.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Duration" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: { placeholder: "Type" },
                                  model: {
                                    value: _vm.newFeatureForm.durationType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newFeatureForm,
                                        "durationType",
                                        $$v
                                      )
                                    },
                                    expression: "newFeatureForm.durationType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "Permanent",
                                      value: "permanent",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "Days", value: "days" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "Months", value: "months" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "Years", value: "years" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.newFeatureForm.durationType !== "permanent"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Value" } },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100px" },
                                    attrs: { min: 1 },
                                    model: {
                                      value: _vm.newFeatureForm.durationValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newFeatureForm,
                                          "durationValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "newFeatureForm.durationValue",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                  },
                                  on: { click: _vm.handleAddFeature },
                                },
                                [_vm._v(" Add ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.featuresDialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }